import React from "react";
import ReactPlayer from "react-player";
import "./index.css";

const VideoCard = ({ item }) => {
  return (
    <div className="hotVideo-card">
      <div className="background">
        <ReactPlayer
          url={item.media_url}
          width="100%"
          height="100%"
          controls={true}
        />
      </div>
    </div>
  );
};
export default VideoCard;



// WEBPACK FOOTER //
// ./src/screens/HotTopic/VideoCard.js